import React from 'react';
import { Phone, Mail, Clock, ChevronRight, User } from 'lucide-react';

const RecentConsultations = ({ requests = [], onViewAll }) => {
  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const formatServiceInterest = (interest) => {
    if (!interest) return 'General Inquiry';
    return interest
      .replace(/-/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase());
  };

  if (!requests || requests.length === 0) {
    return (
      <div className="recent-consultations-panel empty">
        <div className="empty-state">
          <Phone size={24} />
          <p>No consultation requests yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className="recent-consultations-panel">
      <div className="panel-header">
        <h4><Phone size={16} /> Recent Requests</h4>
        {onViewAll && (
          <button className="view-all-btn" onClick={onViewAll}>
            View All <ChevronRight size={14} />
          </button>
        )}
      </div>
      <div className="consultations-list">
        {requests.map((request, index) => (
          <div key={request.id || index} className="consultation-item">
            <div className="consultation-avatar">
              <User size={18} />
            </div>
            <div className="consultation-details">
              <div className="consultation-name">
                {request.first_name} {request.last_name}
              </div>
              <div className="consultation-meta">
                <span className="service-type">
                  {formatServiceInterest(request.service_interest)}
                </span>
                <span className="divider">•</span>
                <span className="time-ago">
                  <Clock size={12} />
                  {formatTimeAgo(request.created_at)}
                </span>
              </div>
            </div>
            <div className="consultation-actions">
              <a 
                href={`mailto:${request.email}`} 
                className="action-btn email"
                title={`Email ${request.email}`}
              >
                <Mail size={16} />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentConsultations;
